import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { Injectable } from "@angular/core";
import { LoggerService } from "@bfx/logger";
import {
  BfxConfigService,
  BfxSysConfigUtilService,
  SystemConfigPromiseService,
} from "shared/auth-services";
import {
  AlgoStrategyLookupService,
  CcyLookupService,
  CcyPairLookupService,
  ClientLookupService,
  CurrencyPairCalendarLookupService,
  ProfilePromiseActionService,
  ProfileSettingKeys,
  SalesGroupLookupService,
  TableDefinition,
  UserLookupService,
} from "shared/cubiq-services";
import { FwdRollBaseTableDefinitionFactory } from "shared/cubiq-services/model/FwdRollBaseTableDefinitionFactory";
import { BfxColDef } from "shared/cubiq-services/model/TableDefinition";
import {
  FWD_ROLL_ORDERS_TABLE_DEFINITION_VER,
  FWD_ROLL_PAIRS_TABLE_DEFINITION_VER,
} from "shared/cubiq-services/model/TableDefinitionFactory.constants";
const logger = LoggerService.for(__dirname);

@Injectable()
export class FwdRollDealtPairTableDefinitionFactory extends FwdRollBaseTableDefinitionFactory {
  constructor(
    profileService: ProfilePromiseActionService,
    ccyPairLookupService: CcyPairLookupService,
    ccyLookupService: CcyLookupService,
    sysConfigService: SystemConfigPromiseService,
    clientLookup: ClientLookupService,
    userLookupService: UserLookupService,
    salesGroupLookup: SalesGroupLookupService,
    currencyPairCalendarLookupService: CurrencyPairCalendarLookupService,
    algoStrategyLookupService: AlgoStrategyLookupService,
    sysConfigUtil: BfxSysConfigUtilService,
    configService: BfxConfigService,
  ) {
    super(
      profileService,
      ccyPairLookupService,
      ccyLookupService,
      sysConfigService,
      clientLookup,
      userLookupService,
      salesGroupLookup,
      currencyPairCalendarLookupService,
      algoStrategyLookupService,
      sysConfigUtil,
      configService,
    );
  }

  public override createDef(): TableDefinition {
    super.createDef();

    // Table definition displaying objects of type FwdRollDealtPairModel
    let td = new TableDefinition("rowId", "rowId");

    // requestSubmissionTime's column
    td.setDefaultSort(1, "desc");

    let selectionColumn: BfxColDef = this.createSelectionColumn();
    td.addColumn(selectionColumn);

    // dealt pair
    let instrumentCol: BfxColDef = this.createNetInstrumentColumn();
    td.addColumn(instrumentCol);

    // direction
    let intentCol: BfxColDef = this.createNetIntentColumn();
    td.addColumn(intentCol);

    // value date
    let valueDateCol: BfxColDef = this.createValueDateColumn();
    td.addColumn(valueDateCol);

    // Position Amount
    let orderAmtCol: BfxColDef = this.createNetFixedAmtColumn();
    td.addColumn(orderAmtCol);

    // Counter Amount
    let counterAmtCol: BfxColDef = this.createNetCounterAmtColumn();
    td.addColumn(counterAmtCol);

    // market forward points
    let marketForwardPointsCol: BfxColDef = this.createMarketForwardPtsColumn();
    td.addColumn(marketForwardPointsCol);

    // agreed forward points
    let agreedForwardPointsCol: BfxColDef = this.createAgreedForwardPtsColumn();
    td.addColumn(agreedForwardPointsCol);

    // adjusted vs agreed forward points percent change
    let agreedPercentChangeCol: BfxColDef = this.createAgreedPercentChangeColumn();
    td.addColumn(agreedPercentChangeCol);

    // fwd markup
    let fwdMarkupCol: BfxColDef = this.createForwardMarkupColumn();
    td.addColumn(fwdMarkupCol);

    // clientPts
    let clientPtsCol: BfxColDef = this.createClientForwardPtsColumn();
    td.addColumn(clientPtsCol);

    // market spot
    let marketSpotCol: BfxColDef = this.createMarketSpotColumn(true);
    td.addColumn(marketSpotCol);

    // market all-in rate
    let marketForwardRateCol: BfxColDef = this.createMarketForwardRateColumn(true);
    td.addColumn(marketForwardRateCol);

    // We currently do not get order counts from the server so we disable this
    // // Order count
    // let orderCountCol: BfxColDef = this.createOrderCountColumn();
    // td.addColumn(orderCountCol);

    // Prevent sorting for Dealt pair table
    td.columns.forEach((col) => (col.sortable = false));

    return td;
  }

  public override getBlotterType(): CubiqTS.BlotterType {
    return null;
  }

  protected override getProfileSettingKey(): string {
    return `${ProfileSettingKeys.userProfileFwdRollBlotters}DealtPairs`;
  }

  public override getVersionIdentifier(): string {
    return FWD_ROLL_PAIRS_TABLE_DEFINITION_VER;
  }
}
